import { ErrorBoundary } from "react-error-boundary";
import { Navigate, Route } from "react-router-dom";
import ErrorPageConnection from "../../components/artsPersonComponent/errorPageConnection";
import AdministracaoCliente from "../../pages/client/5.0-administracao";
import PermissoesCliente from "../../pages/client/5.0-administracao/permissoes";
import AdminUsuarioCliente from "../../pages/client/5.0-administracao/usuario";
import ClientePermissionRoute from "../../pages/client/protectedRoute/ClientePermissionRoute";
import RotaErpCliente from "../../pages/client/protectedRoute/RotaErpCliente";
import ConfiguracoesCliente from "../../pages/client/configuracoes";
import FinanceiroCliente from "../../pages/client/4.0-financeiro";
import Faturas from "../../pages/client/4.0-financeiro/faturas";
import NotaFiscal from "../../pages/client/4.0-financeiro/notaFiscal";
import DisponibilidadeClient from "../../pages/client/2.0-dashboard/2.3-disponibilidade";
import OverviewClient from "../../pages/client/2.0-dashboard/2.1-overview";
import HealthClient from "../../pages/client/2.0-dashboard/2.2-saude";
import DashSfpCliente from "../../pages/client/2.0-dashboard/2.5-sfp";
import LayoutClient from "../../pages/client/layout";
import LayoutDashboardClient from "../../pages/client/layoutDashboard";
import ProtectedRoute from "../../pages/client/protectedRoute/ClienteAdmRoute";
import DashFirewallCliente from "../../pages/client/2.0-dashboard/2.4-dashFortigate";

import RelatoriosDisponiveisParaDownload from "../../pages/client/5.0-relatorios/relatoriosDisponiveis";
import Tickets from "../../pages/client/3.0-tickets";
import ClientViewpoint from "../../pages/internal/11.0-administracao/11.1-usuarios/clientes/modoEspelho";
import DashOnuCliente from "../../pages/client/2.0-dashboard/2.6-onu";
import DashBgp from "../../pages/internal/3.0-dashboard/3.7-linksEsessoes";
import EasyFlow from "../../pages/client/2.0-dashboard/2.8-easyFlow";
import Contratos from "../../pages/client/4.0-financeiro/contratos";

import SugestoesCliente from "../../pages/client/6.0-sugestoes";
import ResumoClient from "../../pages/client/1.0-home";

export default function ClientRoute({
  pathName = "",
  colorMode = false,
  setColorMode = () => {},
}) {
  // Telas de um ERP específico (NFs, Contratos) seguem o ERP do cliente logado
  // (RotaErpCliente), não a variável do sistema.
  const isFinanceHidden =
    window?.config?.REACT_APP_FINANCE_CLIENT ||
    process.env.REACT_APP_FINANCE_CLIENT;

  return (
    <Route element={<ClientViewpoint />}>
      <Route
        element={
          <LayoutClient colorMode={colorMode} setColorMode={setColorMode} />
        }
      >
        {/* Administração continua protegida apenas pela permissão ADM,
				    do mesmo jeito que /interno/administracao no lado interno */}
        <Route
          path={`${pathName}/administracao`}
          element={
            <ProtectedRoute>
              <AdministracaoCliente />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="usuarios" replace />} />
          <Route
            path={`${pathName}/administracao/usuarios`}
            element={<AdminUsuarioCliente />}
          />
          <Route
            path={`${pathName}/administracao/permissoes`}
            element={<PermissoesCliente />}
          />
        </Route>

        <Route element={<ClientePermissionRoute />}>
          <Route
            path={`${pathName}/resumo`}
            element={
              <ErrorBoundary
                FallbackComponent={({ error, resetErrorBoundary }) => (
                  <ErrorPageConnection
                    error={error}
                    resetErrorBoundary={resetErrorBoundary}
                  />
                )}
                resetKeys={[`${pathName}/resumo`]}
              >
                <ResumoClient />
              </ErrorBoundary>
            }
          />
          <Route
            path={`${pathName}/home`}
            element={
              <LayoutDashboardClient
                colorMode={colorMode}
                setColorMode={setColorMode}
              />
            }
          >
            <Route
              path={`${pathName}/home/overview`}
              element={
                <ErrorBoundary
                  FallbackComponent={({ error, resetErrorBoundary }) => (
                    <ErrorPageConnection
                      error={error}
                      resetErrorBoundary={resetErrorBoundary}
                    />
                  )}
                  resetKeys={[`${pathName}/home/overview`]}
                >
                  <OverviewClient />
                </ErrorBoundary>
              }
            />
            <Route
              path={`${pathName}/home/saude`}
              element={
                <ErrorBoundary
                  FallbackComponent={({ error, resetErrorBoundary }) => (
                    <ErrorPageConnection
                      error={error}
                      resetErrorBoundary={resetErrorBoundary}
                    />
                  )}
                  resetKeys={[`${pathName}/home/saude`]}
                >
                  <HealthClient />
                </ErrorBoundary>
              }
            />
            <Route
              path={`${pathName}/home/disponibilidade`}
              element={
                <ErrorBoundary
                  FallbackComponent={({ error, resetErrorBoundary }) => (
                    <ErrorPageConnection
                      error={error}
                      resetErrorBoundary={resetErrorBoundary}
                    />
                  )}
                  resetKeys={[`${pathName}/home/disponibilidade`]}
                >
                  <DisponibilidadeClient />
                </ErrorBoundary>
              }
            />
            <Route
              path={`${pathName}/home/dash/sfp`}
              element={<DashSfpCliente />}
            />
            <Route path={`${pathName}/home/onu`} element={<DashOnuCliente />} />
            <Route
              path={`${pathName}/home/rede`}
              element={
                <DashBgp
                  findLinksUrl={"/cliente/find/resumoLinksBgp"}
                  serieTemporalUrl={"/cliente/zabbix/serieTemporal"}
                  findHostsUrl={"/cliente/findMany/hosts"}
                  findInterfaceListUrl={"/cliente/findMany/interfaces"}
                  findItemsListUrl={"/client/items/list"}
                  findPrefixSessionsUrl={"/cliente/find/prefixSessions"}
                />
              }
            />
            <Route path={`${pathName}/home/flow`} element={<EasyFlow />} />
            <Route
              path={`${pathName}/home/firewall`}
              element={
                <ErrorBoundary
                  FallbackComponent={({ error, resetErrorBoundary }) => (
                    <ErrorPageConnection
                      error={error}
                      resetErrorBoundary={resetErrorBoundary}
                    />
                  )}
                  resetKeys={[`${pathName}/home/firewall`]}
                >
                  <DashFirewallCliente />
                </ErrorBoundary>
              }
            />
          </Route>
          {!isFinanceHidden && (
            <Route
              path={`${pathName}/financeiro`}
              element={<FinanceiroCliente />}
            >
              <Route
                path={`${pathName}/financeiro/faturas`}
                element={
                  <ErrorBoundary
                    FallbackComponent={({ error, resetErrorBoundary }) => (
                      <ErrorPageConnection
                        error={error}
                        resetErrorBoundary={resetErrorBoundary}
                      />
                    )}
                    resetKeys={[`${pathName}/financeiro/faturas`]}
                  >
                    <Faturas />
                  </ErrorBoundary>
                }
              />
              {/* Contratos: cliente VERO ou IXC (no IXC, rota necessária para
						    grupo econômico — o menu só aparece para VERO ou IXC+grupo; a
						    página trata IXC sem grupo) */}
              <Route
                path={`${pathName}/financeiro/contratos`}
                element={
                  <RotaErpCliente tipos={["VERO", "IXC"]}>
                    <ErrorBoundary
                      FallbackComponent={({ error, resetErrorBoundary }) => (
                        <ErrorPageConnection
                          error={error}
                          resetErrorBoundary={resetErrorBoundary}
                        />
                      )}
                      resetKeys={[`${pathName}/financeiro/contratos`]}
                    >
                      <Contratos />
                    </ErrorBoundary>
                  </RotaErpCliente>
                }
              />

              {/* NFs: só cliente HubSoft */}
              <Route
                path={`${pathName}/financeiro/nfs`}
                element={
                  <RotaErpCliente tipos={["HUBSOFT"]}>
                    <NotaFiscal />
                  </RotaErpCliente>
                }
              />
            </Route>
          )}

          <Route
            path={`${pathName}/configuracoes`}
            element={<ConfiguracoesCliente />}
          />

          <Route
            path={`${pathName}/tickets`}
            element={
              <ErrorBoundary
                FallbackComponent={({ error, resetErrorBoundary }) => (
                  <ErrorPageConnection
                    error={error}
                    resetErrorBoundary={resetErrorBoundary}
                  />
                )}
                resetKeys={[`${pathName}/tickets`]}
              >
                <Tickets />
              </ErrorBoundary>
            }
          />
          <Route
            path={`${pathName}/relatorios`}
            element={<RelatoriosDisponiveisParaDownload />}
          />

          <Route
            path={`${pathName}/sugestoes`}
            element={
              <ErrorBoundary
                FallbackComponent={({ error, resetErrorBoundary }) => (
                  <ErrorPageConnection
                    error={error}
                    resetErrorBoundary={resetErrorBoundary}
                  />
                )}
                resetKeys={[`${pathName}/sugestoes`]}
              >
                <SugestoesCliente />
              </ErrorBoundary>
            }
          />
        </Route>
      </Route>
    </Route>
  );
}
